import React, { FocusEvent, forwardRef, useState } from 'react';

import cn from 'classnames';
import DatePicker, { ReactDatePicker } from 'react-datepicker';

import { CalendarSVG } from '@components/svgs';
import { composeEventHandlers } from '@helpers/composeEventHandlers';

import * as BlockableComponents from '../../../types/blockable-components';

export const Date = forwardRef<ReactDatePicker, BlockableComponents.Date>(
  ({ containerClassName, wrapperClassName, className, onFocus, onBlur, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleOnFocus = (_: FocusEvent<HTMLInputElement>) => {
      setIsFocused(true);
    };

    const handleOnBlur = (_: FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
    };

    return (
      <div
        className={cn(
          'flex items-stretch rounded border border-gray-200 bg-white px-4 py-2',
          { 'border-indigo-500 ring-1 ring-indigo-500': isFocused },
          containerClassName
        )}
      >
        <div className='mr-2 flex items-center justify-center'>
          <CalendarSVG />
        </div>
        <div className='w-full'>
          <DatePicker
            ref={ref}
            placeholderText='Date'
            showPopperArrow={false}
            className={cn('w-full border-0 bg-white p-0 text-sm placeholder-gray-400 focus:ring-0', className)}
            wrapperClassName={cn('w-full', wrapperClassName)}
            popperPlacement='bottom'
            popperModifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
            portalId='calendar-portal'
            onFocus={composeEventHandlers(handleOnFocus, onFocus)}
            onBlur={composeEventHandlers(handleOnBlur, onBlur)}
            {...rest}
          />
        </div>
      </div>
    );
  }
);
